// TextBlock.js (or TextBlock.tsx)
import React from 'react';
import './TextBlock.css'
import "bootstrap/dist/css/bootstrap.min.css";


function TextBlockComponent({block, component}) {
  // Implement your component logic here
  const contentStyle = {
    backgroundColor: block.backgroundColor,
  };
  return (
    <div   style={contentStyle} className="text-block">
        {component}
    </div>
  );
}

export default TextBlockComponent;
